import React, { Component } from "react";
import Live from "../components/Live";

import { formatViewers, decrypt } from "../utils";
import axios from "axios";

class Detail extends Component {
  state = {
    streamings: [],
    streaming: null,
    viewCount: 0,
  };

  async componentDidMount() {
    const { location } = this.props;

    const params = new URLSearchParams(location.search);

    const decodeQuery = decodeURIComponent(params.get("stream"));

    const detailResponse = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/v1/streamings/lives/${decrypt(
        decodeQuery
      )}`,
      {
        headers: {
          "x-api-key": "xdxeDyW2Scb6XS8vZ2LtuHxGzHsQrJtjGN8mJQqQm6jHf78u",
        },
      }
    );

    const { streaming } = await detailResponse.data

    /*const listResponse = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/streamings/lives`,
      {
        headers: {
          "x-api-key": "xdxeDyW2Scb6XS8vZ2LtuHxGzHsQrJtjGN8mJQqQm6jHf78u",
        },
      }
    );
    const { data } = await listResponse.json();*/

    this.setState({
      //streamings: data,
      streaming: streaming,
      viewCount: streaming ? streaming.displayViews : 0,
    });
  }

  render() {
    const { streaming, viewCount } = this.state;

    return (
      <Live
        streaming={streaming}
        liveStartedAt={streaming ? streaming.liveStartedAt : "00:00:00"}
        viewCount={formatViewers(viewCount)}
      />
    );
  }
}

export default Detail;
